import { inject, Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { PagedGridAnalyticsActions } from '../../store/paged-grid';

@Injectable({
  providedIn: 'root',
})
export class PagedGridAnalytics {
  private readonly store = inject(Store);
  private readonly ngZone = inject(NgZone);

  trackRenderingTime(instanceId: string, renderingTimeMs: number): void {
    this.ngZone.run(() => this.store.dispatch(PagedGridAnalyticsActions.GridRendered({ instanceId, renderingTimeMs })));
  }
}
